// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2J6xq","name":"ConsentHeader_name__15_bQ","birthday":"ConsentHeader_birthday__1JEZn","skeleton":"ConsentHeader_skeleton__1A0AG"};